(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["le-entrega"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('le-entrega')) {
    customElements.define('le-entrega', class extends HTMLElement {
      connectedCallback() {
        this.updateDate();

        // Atualiza também se a página ficar aberta durante a noite.
        this.dateTimer = window.setInterval(() => {
          this.updateDate();
        }, 60000);
      }

      disconnectedCallback() {
        window.clearInterval(this.dateTimer);
      }

      updateDate() {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        const formatter = new Intl.DateTimeFormat('fr-FR', {
          weekday: 'short',
          day: 'numeric',
          month: 'short'
        });

        const output = this.querySelector('.le-entrega__date');
        if (output) {
          output.textContent = formatter.format(tomorrow);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
